export default __webpack_public_path__ + "static/media/rainbow_11_lightsalmonpink_silver_fire_smirk_tech.91f712b1.png";